// src/components/MiniToolPageLayout.js
import React from 'react';
import SEO from './SEO';
import TryOtherMiniTools from './TryOtherMiniTools';
import StepByStepGuide from './StepByStepGuide';

const MiniToolPageLayout = ({ seo, hero, children, guide }) => {
  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        image={seo.image}
        schemas={seo.schemas}
      />
      <main className="bg-dark-bg text-dark-text-secondary font-sans animate-fade-in">
        <div className="relative isolate pt-32 sm:pt-48">
          <div className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">
            <div 
              className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" 
              style={{ clipPath: 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)' }} 
            />
          </div>
          
          <div className="mx-auto max-w-2xl text-center px-6">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end mb-6">
              <hero.icon className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-4xl font-bold tracking-tight text-dark-text-primary sm:text-6xl">
              {hero.title}
            </h1>
            <p className="mt-6 text-lg leading-8 text-dark-text-secondary">
              {hero.subtitle}
            </p>
          </div>

          <div className="mt-16 sm:mt-24">
            {children}
          </div>

          {guide && (
            <StepByStepGuide 
              title={guide.title}
              subtitle={guide.subtitle}
              steps={guide.steps}
            />
          )}

          {/* Pass the hero title down to be used for exclusion */}
          <TryOtherMiniTools exclude={hero.title} />
        </div>
      </main>
    </>
  );
};

export default MiniToolPageLayout;